module.exports = __webpack_public_path__ + "static/img/001.a88d108.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/001.png
// module id = XXmA
// module chunks = 0